<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <div class="edit">
      <div class="title">公司{{ web == 'edit' ? '编辑' : '新增' }}</div>
      <div class="el-form" label-position="top">
        <el-form ref="addForm" :model="addForm" label-width="130px" :rules="rules">
          <el-row>
            <el-col :xs="24" :sm="12">
              <el-form-item label="公司名称" prop="name">
                <el-input v-model="addForm.name" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="初始用户姓名" prop="userName">
                <el-input v-model="addForm.userName" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="初始用户工号" prop="workNumber">
                <el-input v-model="addForm.workNumber" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="初始用户手机号" prop="phone">
                <el-input v-model="addForm.phone" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item class="roleName" label="区域" prop="qy">
                <el-cascader
                  class="width-100"
                  v-model="addForm.qy"
                  placeholder="请选择区域"
                  :options="options"
                  filterable
                  @change="qyChange"
                >
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="地址" prop="address">
                <el-input v-model="addForm.address" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="可允许使用人数" prop="numberPeople">
                <el-input-number
                  v-model="addForm.numberPeople"
                  :min="1"
                  :step="1"
                  step-strictly
                  placeholder="请输入"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="是否在免费期内" prop="isFreePeriod">
                <el-select v-model="addForm.isFreePeriod" placeholder="请选择">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="有效期" prop="billingPeriod">
                <el-date-picker
                  v-model="addForm.billingPeriod"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="billingPeriodChange"
                ></el-date-picker>
                <!-- <el-date-picker
                  v-model="addForm.startBillingPeriod"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @change="startBillingPeriodChange"
                  clearable
                ></el-date-picker> -->
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="12">
              <el-form-item label="有效期止" prop="phone">
                <el-date-picker
                  v-model="addForm.endBillingPeriod"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @change="endBillingPeriodChange"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="12">
              <el-form-item label="销售经理" prop="salesManagerId">
                <el-select v-model="addForm.salesManagerId" placeholder="请选择" @change="salesManagerChange" clearable>
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in persons" :key="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="价格" prop="price">
                <el-input-number
                  v-model="addForm.price"
                  :min="0"
                  :step="100"
                  step-strictly
                  placeholder="请输入"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="addForm.remark" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="btn">
            <el-button
              v-permissions="'company:add'"
              v-show="!addForm.id"
              type="primary"
              size="small"
              class="save"
              @click="addSave('addForm')"
              >保存
            </el-button>
            <el-button
              v-permissions="'company:update'"
              v-show="addForm.id"
              type="primary"
              size="small"
              class="save"
              @click="editSave('addForm')"
              >保存
            </el-button>
            <el-button v-permissions="'company:query'" type="primary" size="small" plain class="cancel" @click="cancel"
              >返回列表</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import cityData from '../../utils/Data'
// import selfTitle from '../components/Title'
export default {
  name: 'User',
  // components: {
  //   selfTitle
  // },
  data() {
    return {
      userInfo: {},
      titles: ['公司管理', '公司详情'],
      web: '',
      addForm: {
        id: '',
        userId: '',
        name: '', // 公司名称
        userName: '', // 初始用户姓名
        workNumber: '', // 初始用户工号
        phone: '', // 初始用户手机号
        qy: [],
        area1: '', // 区域1
        area2: '', // 区域2
        area3: '', // 区域3
        address: '', // 地址
        numberPeople: '', // 可允许使用人数
        isFreePeriod: '', // 是否在免费期内
        billingPeriod: [],
        startBillingPeriod: '', // 有效期始
        endBillingPeriod: '', // 有效期止
        price: '', // 价格
        salesManagerId: '', // 销售经理id
        salesManagerName: '', // 销售经理姓名
        remark: '' // 备注
      },
      cycle2: [
        { code: '30', name: '30天' },
        { code: '60', name: '60天' },
        { code: '90', name: '90天' },
        { code: '120', name: '120天' },
        { code: '180', name: '180天' },
        { code: '360', name: '360天' }
      ],
      options: cityData, // 全国省市
      persons: [], // 所有公司员工
      rules: {
        userName: [{ required: true, message: '请输入初始用户姓名', trigger: 'blur' }],
        workNumber: [{ required: true, message: '请输入初始用户工号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        numberPeople: [{ required: true, message: '请输入可允许使用人数', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        isFreePeriod: [{ required: true, message: '请选择是否在免费期内', trigger: 'change' }],
        billingPeriod: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        startBillingPeriod: [{ required: true, message: '请选择有效期始', trigger: 'change' }],
        endBillingPeriod: [{ required: true, message: '请选择有效期止', trigger: 'change' }],
        salesManagerId: [{ required: true, message: '请选择销售经理', trigger: 'change' }],
        address: [{ required: true, message: '请填写地址', trigger: 'blur' }],
        phone: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(rule.msg)
              } else {
                const reg = /^[1][3-9][0-9]{9}$/
                reg.test(value) ? callback() : callback('请输入正确的手机号码')
              }
            },
            msg: '请输入手机号码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // 区域更改
    qyChange(val) {
      if (val) {
        this.addForm.area1 = val[0]
        this.addForm.area2 = val[1]
        this.addForm.area3 = val[2]
      }
    },
    // 有效期止改变
    billingPeriodChange(val) {
      if (val) {
        this.addForm.startBillingPeriod = val[0]
        this.addForm.endBillingPeriod = val[1]
      } else {
        this.addForm.startBillingPeriod = ''
        this.addForm.endBillingPeriod = ''
      }
    },
    // 有效期止改变
    startBillingPeriodChange(val) {
      const starttime = this.$common.timeFormat(new Date(val.replace(/\-/g, '/')), 'yyyy-MM-dd 00:00:00')
      if (this.addForm.endBillingPeriod) {
        const endtime = this.$common.timeFormat(
          new Date(this.addForm.endBillingPeriod.replace(/\-/g, '/')),
          'yyyy-MM-dd 00:00:00'
        )
        if (starttime > endtime) {
          this.$root.$children[0].vueAlert({ message: '有效期始不能大于有效期止', type: 'error' })
        }
      }
    },
    // 有效期止改变
    endBillingPeriodChange(val) {
      const endtime = this.$common.timeFormat(new Date(val.replace(/\-/g, '/')), 'yyyy-MM-dd 00:00:00')
      if (this.addForm.startBillingPeriod) {
        const starttime = this.$common.timeFormat(
          new Date(this.addForm.startBillingPeriod.replace(/\-/g, '/')),
          'yyyy-MM-dd 00:00:00'
        )
        if (starttime > endtime) {
          this.$root.$children[0].vueAlert({ message: '有效期止不能小于有效期始', type: 'error' })
        }
      }
    },
    // 客户经理选择变化
    salesManagerChange(val) {
      for (let i = 0; i < this.persons.length; i++) {
        if (this.persons[i].id === val) {
          this.addForm.salesManagerName = this.persons[i].name
        }
      }
      console.log(this.addForm)
    },
    titleClick(item, index) {
      console.log(item, index)
      if (item === '公司管理') {
        this.web = 'main'
        this.titles = ['公司管理'] // 导航菜单
        this.cancel()
      }
    },
    // 获取所有员工
    queryUserIdName() {
      const param = {}
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 获取所有员工
    detail() {
      const param = {
        id: this.addForm.id
      }
      this.$get('/company/detail', param).then(
        result => {
          if (result.status === 200) {
            const company = result.data.aosCompany
            const user = result.data.user
            for (const i in company) {
              this.addForm[i] = company[i]
            }
            this.addForm.userName = user.name
            this.addForm.phone = user.phone
            this.addForm.workNumber = user.workNumber
            this.addForm.userId = user.id
            this.addForm.address = user.address
            this.addForm.qy = [this.addForm.area1, this.addForm.area2, this.addForm.area3]
            this.addForm.billingPeriod = [this.addForm.startBillingPeriod, this.addForm.endBillingPeriod]
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    addSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const param = {
            name: this.addForm.name, // 公司名称
            userName: this.addForm.userName, // 初始用户姓名
            workNumber: this.addForm.workNumber, // 初始用户工号
            phone: this.addForm.phone, // 初始用户手机号
            address: this.addForm.address, // 地址
            area1: this.addForm.area1, // 区域1
            area2: this.addForm.area2, // 区域2
            area3: this.addForm.area3, // 区域3
            numberPeople: this.addForm.numberPeople, // 可允许使用人数
            isFreePeriod: this.addForm.isFreePeriod, // 是否在免费期内
            startBillingPeriod: this.$common.timeFormat(
              new Date(this.addForm.startBillingPeriod.replace(/\-/g, '/')),
              'yyyy-MM-dd 00:00:00'
            ), // 有效期始
            endBillingPeriod: this.$common.timeFormat(
              new Date(this.addForm.endBillingPeriod.replace(/\-/g, '/')),
              'yyyy-MM-dd 00:00:00'
            ), // 有效期止
            price: this.addForm.price, // 价格
            salesManagerId: this.addForm.salesManagerId, // 销售经理id
            salesManagerName: this.addForm.salesManagerName, // 销售经理姓名
            remark: this.addForm.remark // 备注
          }
          this.$post('/company/add', param).then(
            result => {
              if (result.status === 200) {
                // this.web = 'main'
                // this.titles = ['公司管理']
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                // this.cancel()
                this.$router.push({
                  name: 'CompanyDetail',
                  params: {
                    id: result.data.aosCompany.id,
                    webState: 'edit'
                  }
                })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log('通过')
          const param = {
            id: this.addForm.id,
            userId: this.addForm.userId,
            name: this.addForm.name, // 公司名称
            userName: this.addForm.userName, // 初始用户姓名
            workNumber: this.addForm.workNumber, // 初始用户工号
            phone: this.addForm.phone, // 初始用户手机号
            address: this.addForm.address, // 地址
            area1: this.addForm.area1, // 区域1
            area2: this.addForm.area2, // 区域2
            area3: this.addForm.area3, // 区域3
            numberPeople: this.addForm.numberPeople, // 可允许使用人数
            isFreePeriod: this.addForm.isFreePeriod, // 是否在免费期内
            startBillingPeriod: this.$common.timeFormat(
              new Date(this.addForm.startBillingPeriod.replace(/\-/g, '/')),
              'yyyy-MM-dd 00:00:00'
            ), // 有效期始
            endBillingPeriod: this.$common.timeFormat(
              new Date(this.addForm.endBillingPeriod.replace(/\-/g, '/')),
              'yyyy-MM-dd 00:00:00'
            ), // 有效期止
            price: this.addForm.price, // 价格
            salesManagerId: this.addForm.salesManagerId, // 销售经理id
            salesManagerName: this.addForm.salesManagerName, // 销售经理姓名
            remark: this.addForm.remark // 备注
          }
          this.$post('/company/update', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                // this.cancel()
                this.detail()
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancel() {
      this.addForm = {
        name: '', // 公司名称
        userName: '', // 初始用户姓名
        workNumber: '', // 初始用户工号
        phone: '', // 初始用户手机号
        address: '', // 地址
        qy: [],
        area1: '', // 区域1
        area2: '', // 区域2
        area3: '', // 区域3
        numberPeople: '', // 可允许使用人数
        isFreePeriod: '', // 是否在免费期内
        startBillingPeriod: '', // 有效期始
        endBillingPeriod: '', // 有效期止
        price: '', // 价格
        salesManagerId: '', // 销售经理id
        salesManagerName: '', // 销售经理姓名
        remark: '' // 备注
      }
      this.$router.push({
        name: 'Company'
      })
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    } else {
      return this.$root.$children[0].vueAlert({ message: '未获取到公司信息', type: 'warning' })
    }
    this.web = this.$route.params.webState
    this.addForm.id = this.$route.params.id
    this.addForm.qy = [this.userInfo.area1 || '', this.userInfo.area2 || '', this.userInfo.area3 || '']
    this.addForm.area1 = this.userInfo.area1
    this.addForm.area2 = this.userInfo.area2
    this.addForm.area3 = this.userInfo.area3
    if (this.addForm.id) {
      this.detail()
    }
    this.queryUserIdName()
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped></style>
